
import React, {Component} from "react";
import PageTitle from "../../Components/Theme/PageTitle";
import DashboardLayout from "../../Components/Theme/DashboardLayout";

export default class BlankPage extends Component {


    render() {
        return (
            <DashboardLayout>
                {/*** Page Title ***/}
                <PageTitle title={'Blank Page'}
                           subTitle={'New Blank Page'}/>

            </DashboardLayout>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Pages/Theme/Page.js